export const attendanceStatus = {
  'Presente': 'Presente',
  'Ausente': 'Ausente'
}
